const translation = {
  toVerifiedTip: {
    end: 'za profesionalni načrt Dify.',
    front: 'Zdaj ste upravičeni do statusa Preverjeno izobraževanje. Prosimo, vnesite svoje izobraževalne podatke spodaj, da zaključite postopek in prejmete',
    coupon: 'izključno 100% kupon',
  },
  form: {
    schoolName: {
      placeholder: 'Vpišite uradno, neokrnjeno ime vaše šole',
      title: 'Ime vaše šole',
    },
    schoolRole: {
      option: {
        administrator: 'Šolski administrator',
        teacher: 'Učitelj',
        student: 'Študent',
      },
      title: 'Vaša šolska vloga',
    },
    terms: {
      desc: {
        and: 'in',
        termsOfService: 'Pogoji storitve',
        end: '. Z oddajo:',
        privacyPolicy: 'Politika zasebnosti',
        front: 'Vaše informacije in uporaba statusa preverjene izobrazbe so predmet naših',
      },
      option: {
        inSchool: 'Potrjujem, da sem vpisan ali zaposlen na navedenem zavodu. Dify lahko zahteva dokazilo o vpisu/zaposlitvi. Če napačno predstavim svojo upravičenost, se strinjam, da plačam morebitne pristojbine, ki so bile sprva oproščene na podlagi mojega izobraževalnega statusa.',
        age: 'Potrjujem, da sem star najmanj 18 let',
      },
      title: 'Pogoji in dogovori',
    },
  },
  toVerified: 'Preverite izobrazbo',
  successContent: 'Za vaše račune smo izdali kupon za 100% popust na profesionalni načrt Dify. Kupon je veljaven eno leto, prosimo, uporabite ga v veljavnem obdobju.',
  successTitle: 'Imate verifikacijo izobraževanja Dify',
  submitError: 'Pošiljanje obrazca ni uspelo. Prosimo, poskusite znova kasneje.',
  submit: 'Predloži',
  rejectTitle: 'Vaša Dify izobraževalna verifikacija je bila zavrnjena.',
  learn: 'Naučite se, kako preveriti izobrazbo',
  emailLabel: 'Vaš trenutni elektronski naslov',
  currentSigned: 'Trenutno prijavljen kot',
  rejectContent: 'Na žalost niste upravičeni do statusa Verificirane izobrazbe in zato ne morete prejeti ekskluzivnega 100-odstotnega kupona za Dify profesionalni načrt, če uporabljate ta e-poštni naslov.',
}

export default translation
